/**
* 纠纷列表
*/
<template>
  <div>
    <!-- 头部导航 -->
    <!--<div style="display: inline-block">
      <span>
        <van-icon name="arrow-left" /> 返回
      </span>
      <span>纠纷列表</span>
      <span>
        <van-icon name="plus" />
      </span>
    </div>-->
    <van-nav-bar placeholder title="纠纷列表" left-text="" left-arrow @click-left="onClickLeft()">
      <template #right>
        <van-icon name="plus" size="18" @click="goToPage(null, 2)"/>
      </template>
    </van-nav-bar>
<!--    &lt;!&ndash;搜索&ndash;&gt;-->
<!--    <div>-->
<!--      <van-search-->
<!--              v-model="queryParams.name"-->
<!--              show-action-->
<!--              placeholder="请输入搜索关键词"-->
<!--              @search="onSearch"-->
<!--      >-->
<!--        <template #action>-->
<!--          <div @click="onSearch">搜索</div>-->
<!--        </template>-->
<!--      </van-search>-->
<!--    </div>-->

    <!-- 列表数据 -->
    <van-pull-refresh v-model="data.topLoading" @refresh="refresh()">
      <van-list
              v-model="data.bottomLoading"
              :finished="!data.hasMore"
              finished-text="没有更多了"
              @load="onLoad"
      >
        <div class="tech-box"  v-for="item in data.records" :key="item.id" @click="goToPage(item, 1)">
          <div class="tech-top">
            <h2>纠纷类型：<b>{{ filterLabelName(disputeTypeOption, item.disputeType) }}</b></h2>
            <h2>发起方：<b>{{ filterLabelName(applySideOption, item.applySide) }}</b></h2>
          </div>
          <div class="time">
            <h2>提出时间：<b>{{ moment(item.applyTime).format("YYYY/MM/DD HH:mm") }}</b></h2>
            <span class="yhf" v-if="item.status==='0'">未调处</span>
            <span class="dhf" v-else>已调处</span>
          </div>
          <div class="tech-top">
            <h2>调处结果：<b>{{ filterLabelName(mediateResultOption, item.mediateResult) }}</b></h2>
          </div>

        </div >
      </van-list>
    </van-pull-refresh>

  </div>
</template>

<script>

  import {FILE_DISPLAY_PREFIX} from '@/api/upload'
  import {getDictByType,filterLabelName, conversionDict} from '@/api/common'
  import {queryList} from '@/api/dispute/disputeInfo'
  import {handlePageData} from '@/utils/common'
  import moment from 'moment'

  export default {
    name: 'DisputeList',
    components: {
    },
    data () {
      return {
        moment,
        filterLabelName,
        mediateResultOption: [],
        statusOption: [{ label: '待调处', value: '0' }, { label: '已调处', value: '1' }],
        disputeTypeOption: [{ label: "销课争议", value: '1' }, { label: "退费争议", value: '2' }, { label: "其他", value: '3' }],
        applySideOption: [],
        show: false,
        fileDisplayPrefix: FILE_DISPLAY_PREFIX,
        facultyTypeOptions: [],
        queryParams: {},
        data: {
          records: [],
          current: 1,
          size: 10,
          total: 0,
          hasMore: true,
          loading: false,
          topLoading: false,
          bottomLoading: false
        },
      }
    },
    computed: {
    },
    created () {
      // 发起方
      getDictByType('apply_side_type').then(res => {
        this.applySideOption = conversionDict(res)
      });
      // 调解结果状态
      getDictByType('mediate_result').then(res => {
        this.mediateResultOption = conversionDict(res)
      })
      this.refresh()
    },
    mounted () {
    },
    methods: {
      onSearch() {
        this.refresh()
      },
      // 加载数据
      onLoad() {
        if (this.data.current > 1 && this.data.hasMore) {
          this.getDataList()
        }
      },
      // 获取列表数据
      getDataList () {
        if (this.data.loading) return;
        this.data.loading = true;
        this.queryParams.current = this.data.current;
        this.queryParams.size = this.data.size;
        queryList(this.queryParams).then(res => {
          if (res.code === 10000) {
            setTimeout(() => {
              handlePageData(this.data, res.result)
            }, 100)
          }
        }).finally(() => {
          setTimeout(() => {
            this.data.loading = false;
            this.data.topLoading = false;
            this.data.bottomLoading = false
          }, 100)
        })
      },
      // 数据字典
      getDict() {
        // 查询字典，院系类型
        getDictByType('faculty_type').then(res => {
          if (res.code === 10000) {
            this.facultyTypeOptions = res.result.map(item => {
              return {label: item.dictKey, value: item.dictValue}
            })
          }
        });
      },
      // 刷新列表
      refresh () {
        this.reset();
        this.getDataList();
      },
      reset() {
        this.data.current = 1;
        this.data.total = 0;
        this.data.hasMore = true
      },
      onClickLeft() {
        this.$router.go(-1)
      },
      //详情页面跳转 type: 1-详情页面 2-添加页面
      goToPage(item, type){
        switch (type) {
          case 1:
            //详情页面
            this.$router.push({path: `/disputeList/detail?id=${item.id}`});
            break;
          case 2:
            //添加页面
            this.$router.push({path: `/disputeList/Add`});
            break;
          default:
        }
      }
    }
  }
</script>

<style scoped>
  .tech-list{
    border: 1px solid;
    margin-bottom: 10px;
  }

  /deep/.van-list{
    padding: 10px;
  }
  .tech-box {
    background: #F4F5F7;
    border-radius:12px;
    margin-bottom: 10px;
    padding: 16px;
  }
  .tech-top{
    display: flex;
    height:14px;
    align-items: center;
    justify-content: space-between;
    flex: none;
    flex-grow: 0;
    gap: 10px;
  }
  .tech-top h2{
    display: flex;
    height:14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #777777;
    line-height:14px;
  }
  .tech-top h2 b{
    display: flex;
    height:14px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height:14px;
  }
  .time span{
    display: flex;
    align-items: center;
    justify-content: center;
    width:58px;
    height:24px;
    border-radius:100px;
    font-size:12px;
    font-family: Microsoft YaHei;
    font-weight: bold;
  }
span.dhf{
    border: 1px solid #FF0000;
    color: #FF0000;
  }
span.yhf{
    border: 1px solid #A7A7A7;
    color:#A7A7A7;
  }
  .time{
    display: flex;
    align-items:center;
    height:24px;
    font-size:14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #000000;
    line-height: 0px;
    color:#777777 ;
    margin-top:16px;
    margin-bottom: 16px;
    justify-content: space-between;
  }
  .time b{
    color: #000000;
  }
</style>
